import React, { useState } from 'react';
import { RevoltModal, RevoltButton, RevoltSwitch } from '../../../../../components';

/**
 * DeleteConfirmationModal Component
 * Confirmation modal for deleting models with optional file deletion
 */
function DeleteConfirmationModal({ isOpen, onClose, model, onConfirmDelete }) {
  const [deleteFile, setDeleteFile] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  if (!model) return null;

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirmDelete(model.id, deleteFile);
      onClose();
    } catch (error) {
      console.error('Failed to delete model:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleClose = () => {
    if (!isDeleting) {
      setDeleteFile(false); // Reset switch when closing
      onClose();
    }
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={handleClose}
      title=""
      showCloseButton={false}
      closeOnBackdrop={!isDeleting}
      containerClassName="delete-confirmation-modal-container"
    >
      <div className="delete-confirmation-modal">
        <div className="delete-confirmation-header">
          <div className="delete-confirmation-icon">
            <i className="fa-solid fa-triangle-exclamation"></i>
          </div>
          <h2>Delete Model</h2>
          <p className="delete-confirmation-model-name">"{model.displayName}"</p>
        </div>

        <div className="delete-confirmation-content">
          <div className="delete-confirmation-message">
            <p>This will permanently remove this model from your model list.</p>
            <p>The model configuration and settings will be deleted.</p>
          </div>

          <div className="delete-file-option">
            <div className="delete-file-header">
              <h4>Also delete the model file</h4>
              <RevoltSwitch
                checked={deleteFile}
                onChange={setDeleteFile}
                size="default"
              />
            </div>
            <p className="delete-file-description">
              {deleteFile
                ? "The model file will be permanently deleted from your computer."
                : "The model file will remain on your computer."
              }
            </p>
            {deleteFile && (
              <div className="delete-file-warning">
                <i className="fa-solid fa-exclamation-triangle"></i>
                <span>This action cannot be undone. The file will be permanently deleted.</span>
              </div>
            )}
          </div>
        </div>

        <div className="delete-confirmation-actions">
          <RevoltButton
            variant="secondary"
            onClick={handleClose}
            disabled={isDeleting}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="danger"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : `Delete Model${deleteFile ? ' & File' : ''}`}
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default DeleteConfirmationModal;